import axios from 'axios';
import React, { useState } from 'react'
import Swal from 'sweetalert2';

export default function SearchBarOrder({ data, setResult, setPending, setTotalRows, setPerPage, setDatasSearch }) {
    const [datas, setDatas] = useState({ method: "orderDate" });
    // const handleSearch = (e) => {
    //     const value = (e.target.value).toUpperCase()

    //     const result = data?.filter(x => x.productName?.toUpperCase()?.includes(value) || x.productCode?.includes(value) || x.model?.toUpperCase()?.includes(value)
    //         || x.orderDate?.includes(value) || x.ordersCode?.includes(value) || x.customer?.includes(value) || x.tel?.includes(value) || x.note?.toUpperCase()?.includes(value)
    //         || x.status?.toUpperCase()?.includes(value) || x.sales?.toUpperCase()?.includes(value) || x.trackingNumber?.includes(value) || x.social?.includes(value))
    //     setResult(result)
    // }

    const handleData = (e) => {
        setDatas({ ...datas, [e.target.name]: e.target.value })

        if (e.target.value === "") {
            setDatasSearch("")
            setPending(true);
            axios.get(`http://${process.env.REACT_APP_API_URL}/orders/count`, {
                headers: {
                    Bearer: localStorage.getItem('token')
                }
            }).then((response) => {
                if (response.status === 200) {
                    setTotalRows(response.data.totals);
                }
            }
            ).catch((error) => {
                if (error.response.data.status === 401) {
                    window.location.href = "/auth/login";
                }
                console.log(error);
            });
           

            axios.post(`http://${process.env.REACT_APP_API_URL}/orders/search-all`, { page: 1, pageSize: 10 }, {
                headers: {
                    bearer: localStorage.getItem('token')
                }
            }).then((response) => {
                if (response.status === 200) {
                    setResult(response.data);
                    setPerPage(10)
                    setPending(false);
                }
            }
            ).catch((error) => {
                if (error.response.data.status === 401) {
                    window.location.href = "/auth/login";
                }
                console.log(error.response.data.message);
            });
        }
    }

    const handleButton = (e) => {
        setPending(true);
        axios.post(`http://${process.env.REACT_APP_API_URL}/orders/search-all-like`, datas, {
            headers: {
                bearer: localStorage.getItem('token')
            }
        }).then((response) => {

            if (response.status === 200) {
                setDatasSearch(response.data);
                setTotalRows(response.data.length);
                setPerPage(response.data.length)
                setPending(false);
            }
        }
        ).catch((error) => {
            if (error.response.data.status === 401) {
                window.location.href = "/auth/login";
            }
            console.log(error.response.data.message);
            Swal.fire({
                icon: 'error',
                title: 'ไม่พบข้อมูลที่ค้นหา',
            })
            setDatasSearch("")
            setPending(false);
        });
    }

    const handleEnter = (e) => {
        if (e.key === 'Enter') {
            handleButton()
        }
    }

    return (
        // <div style={{display:"flex", justifyContent:"center" }} className='w-full'>
        <>
            {/* {data && <div className='relative'>
                <input type='text' placeholder='SearchBar' style={{ borderRadius: "20px", width: "300px" }} onChange={handleSearch} />
                <i className="absolute mt-3 fas fa-search" style={{ marginLeft: "-35px" }}></i>
            </div>} */}
            <div className='relative'>
                <select name="method" id="method" className="mr-2 rounded " onChange={handleData}>
                    {/* <option value="" disabled selected>เลือกหัวข้อค้นหา</option> */}
                    <option value="orderDate" >วันที่เบิก</option>
                    <option value="ordersCode" >หมายเลขOrder</option>
                    <option value="trackingNumber" >หมายเลขติดตาม</option>
                    <option value="customer" >ชื่อลูกค้า</option>
                    <option value="sales" >Sales</option>
                    <option value="social" >โซเชียล</option>
                    <option value="tel" >เบอร์โทรศัพท์</option>
                    <option value="note" >หมายเหตุ</option>
                    <option value="status" >สถานะ</option>
                </select>

                {datas.method == "orderDate" ? <input className="px-4 py-3 mb-3 leading-tight text-gray-700 bg-gray-200 border border-gray-200 rounded appearance-none focus:outline-none focus:bg-white"
                    id="keyword" name="keyword" type="date" max={new Date().toISOString("en").split("T")[0]} onChange={handleData} />
                    :
                    datas.method == "status" ? <select name="keyword" id="keyword" className="rounded" onChange={handleData}>
                        <option value="">เลือกสถานะ</option>
                        <option value="Opened" >Opened</option>
                        <option value="Cancelled" >Cancelled</option>
                        <option value="Waiting Shipping" >Waiting Shipping</option>
                        <option value="Shipping" >Shipping</option>
                        <option value="Waiting Return" >Waiting Return</option>
                        <option value="Completed" >Completed</option>
                        <option value="Claim" >Claim</option>
                        <option value="Return" >Return</option>
                        <option value="Lost" >Lost</option>
                    </select> :
                        <>
                            <input type='text' name='keyword' style={{ borderRadius: "20px", width: "300px" }} onChange={handleData} onKeyDown={handleEnter} />
                            <i className="absolute mt-3 fas fa-search" style={{ marginLeft: "-35px" }}></i>
                        </>
                }
                <button className="px-4 py-2 ml-2 font-bold rounded" style={{ backgroundColor: !datas.keyword ? "#9CA3AF" : "#60A5FA" }} disabled={!datas.keyword} onClick={handleButton}>Search</button>
            </div>
        </>

    )
}
